import { del, get, post, put } from '@/utils/request'

export function genAiMindmap<T = any>(
  data: { conversation_id?: string | number; query: string; workspace_id: string | number },
) {
  return post<T>({
    url: 'agents-service/generate-mindmap/blocking',
    data,
    timeout: 300000,
  })
}

export function genAiMindmapStreaming<T = any>(
  data: { conversation_id?: string | number; query: string; workspace_id: string | number },
) {
  return post<T>({
    url: 'agents-service/generate-mindmap/streaming',
    data: { ...data, response_mode: 'streaming' },
    adapter: 'fetch',
    responseType: 'stream',
    timeout: 300000, // 5 minutes timeout for streaming
  })
}

export function getDetailMinmap<T = any>(
  id: string | number,
) {
  return get<T>({
    url: `agents-service/generate-mindmap/getDetail/${id}`,
  })
}

export function getListMindmap<T = any>(data: { workspace_id: string | number; conversation_id?: string | number }) {
  return post<T>({
    url: 'agents-service/generate-mindmap/listMindmap',
    data,
  })
}

export function updateMindmap<T = any>(data: { id: string | number; mindmap_data: any }) {
  return put<T>({
    url: `agents-service/generate-mindmap/update/${data.id}`,
    data,
  })
}

export function deleteMindmap<T = any>(id: string | number) {
  return del<T>({
    url: `agents-service/generate-mindmap/delete/${id}`,
  })
}
